import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import {
  faSort,
  faSortUp,
  faSortDown,
  faPaperclip,
  faCircle,
  faQuestion,
  faSyncAlt,
  faSearch,
  faPlus,
  faLock,
  faCaretDown,
  faCaretUp,
  faCaretRight,
  faCaretLeft,
  faTimes,
  faCheck,
  faCity,
  faSheetPlastic,
  faGift,
  faPencilAlt,
  faEyeSlash,
  faEye,
  faEnvelope,
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
  faArrowsAltH,
  faArrowsAltV,
  faBoxOpen,
  faBox,
  faArrowDown,
  faArrowUp,
  faArrowUpRightDots,
  faArrowsUpDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightLong,
  faCommentAlt,
  faSliders,
  faFileExcel,
  faExclamationCircle,
  faExclamationTriangle,
  faFileImage,
  faFilePdf,
  faEllipsis,
  faEllipsisV,
  faChevronDown,
  faChevronUp,
  faCog,
  faBookOpen,
  faBank,
  faList,
  faCreditCard,
  faRightLeft,
  faCircleCheck,
  faMoneyBill,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCcVisa,
  faCcMastercard,
  faCcStripe,
} from '@fortawesome/free-brands-svg-icons';
import {
  faCircleQuestion,
  faCopy,
  faCircleXmark,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faExclamationCircle,
  faExclamationTriangle,
  faCircleQuestion,
  faSort,
  faSortUp,
  faSortDown,
  faPaperclip,
  faCircle,
  faQuestion,
  faCircleXmark,
  faEyeSlash,
  faSyncAlt,
  faSearch,
  faPlus,
  faLock,
  faCaretDown,
  faCaretUp,
  faTimes,
  faCheck,
  faCopy,
  faCaretRight,
  faCaretLeft,
  faCity,
  faSheetPlastic,
  faGift,
  faPencilAlt,
  faEnvelope,
  faCircleXmark,
  faEye,
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
  faArrowsAltH,
  faArrowsAltV,
  faBoxOpen,
  faBox,
  faArrowDown,
  faArrowUp,
  faArrowUpRightDots,
  faArrowsUpDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightLong,
  faCommentAlt,
  faSliders,
  faCcVisa,
  faCcMastercard,
  faCcStripe,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faEllipsis,
  faChevronDown,
  faChevronUp,
  faEllipsisV,
  faCog,
  faBookOpen,
  faBank,
  faList,
  faCreditCard,
  faRightLeft,
  faCircleCheck,
  faMoneyBill,
);

export default FontAwesomeIcon;
